import HarIdxFrame from "../../components/HarIdxFrame";

export default function HarNeighborhoodsPage() {
  return (
    <HarIdxFrame
      eyebrow="HAR · Neighborhoods"
      title="Explore Houston neighborhoods"
      description="Deep data on Houston-area neighborhoods — demographics, schools, commute, and active listings — via HAR.com."
      path="neighborhood/search"
      seoPath="/har-neighborhoods"
    />
  );
}
